import type { AttributionDraftShape } from './onboarding-state.js';

/**
 * The landing hands attribution over in the query string, because the reference code lives in
 * localStorage on the landing's origin and the console — a different origin — cannot read it.
 *
 * This is marketing attribution, not authorization: it is client-supplied and therefore
 * forgeable, and nothing security-relevant reads it.
 */
export const handoffParams = ['ref', 'platform', 'click_id', 'click_id_type'] as const;

export function readLandingHandoff(search: string): AttributionDraftShape | null {
  const params = new URLSearchParams(search);
  const referenceCode = params.get('ref')?.trim() ?? '';

  if (!referenceCode) {
    return null;
  }

  return {
    referenceCode,
    platform: params.get('platform')?.trim() ?? '',
    clickId: params.get('click_id')?.trim() ?? '',
    clickIdType: params.get('click_id_type')?.trim() ?? '',
  };
}

/** Returns the path with the handoff params removed, so the URL does not stay noisy. */
export function pathWithoutHandoff(pathname: string, search: string): string {
  const params = new URLSearchParams(search);

  for (const name of handoffParams) {
    params.delete(name);
  }

  const rest = params.toString();

  if (!rest) {
    return pathname;
  }

  return `${pathname}?${rest}`;
}
